// src/shared/api/storage.js
const KEY = 'authTokens';

export const tokenStorage = {
  get() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed?.accessToken) return null;
      return parsed;
    } catch {
      return null;
    }
  },

  set(tokens) {
    try {
      localStorage.setItem(KEY, JSON.stringify(tokens));

      // ✅ EN KRİTİK SATIR
      window.dispatchEvent(new Event('solis:auth:changed'));
    } catch (e) {
      console.error('tokenStorage.set failed:', e);
    }
  },

  clear() {
    localStorage.removeItem(KEY);

    // ✅ logout için de sinyal
    window.dispatchEvent(new Event('solis:auth:changed'));
  },
};
